import { API } from '@/api';
import { DIALOGS } from '@/constants/dialogs';
import {
  Dictionary,
  NewFileNotification,
  NewFinancialReportNotification,
  NewPostNotification,
  Notification,
  NOTIFICATION_TYPE_ID,
} from '@flemingmetrics/api-client';

export const DEFAULT_DIALOGS: Dictionary<boolean> = {
  [DIALOGS.LOGIN]: false,
  [DIALOGS.SEARCH]: false,
  [DIALOGS.SHORTCUTS]: false,
};

export function updateReadNotification(notificationId: number) {
  return API.Notifications.updateNotification(notificationId, { isRead: true });
}

export function isPostNotification(
  notification: Notification
): notification is NewPostNotification {
  return notification.notificationTypeId === NOTIFICATION_TYPE_ID.NEW_POST;
}

export function isFileNotification(
  notification: Notification
): notification is NewFileNotification {
  return notification.notificationTypeId === NOTIFICATION_TYPE_ID.NEW_FILE;
}

export function isFinancialReportNotification(
  notification: Notification
): notification is NewFinancialReportNotification {
  return (
    notification.notificationTypeId ===
    NOTIFICATION_TYPE_ID.NEW_FINANCIAL_REPORT
  );
}
